import { createReducer, on } from '@ngrx/store';
import { createAction, props } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState, Update } from '@ngrx/entity';
import { CompanySurveyConfig } from '../../account/survey.card.feed/survey.feed.model';

export interface SurveyState extends EntityState<CompanySurveyConfig> {
}

export const feedSurveyLoaded = createAction(
    '[FEED SURVEY CARD] loaded survey data',
    props<{ surveys: CompanySurveyConfig[] }>()
);

export const feedSurveyUpdate = createAction(
    '[FEED SURVEY CARD] updated survey',
    props<{ survey: CompanySurveyConfig }>()
);

export const adapter: EntityAdapter<CompanySurveyConfig> = createEntityAdapter<CompanySurveyConfig>({
    selectId: (survey: CompanySurveyConfig) => survey.type
});

const initialSurveyState: SurveyState = adapter.getInitialState();

const _surveyReducer = createReducer(
    initialSurveyState,
    on(feedSurveyLoaded, (state, { surveys }) => {
        return adapter.addMany(surveys, state);
    }),
    on(feedSurveyUpdate, (state, { survey }) => {
        const updateRecognition: Update<CompanySurveyConfig> = {
            id: survey.type,
            changes: survey
        };
        return adapter.updateOne(updateRecognition, state);
    })
);

export function surveyReducer(state: SurveyState | undefined, action: any): SurveyState {
    return _surveyReducer(state, action);
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();
